<template>
    <div class="w3-margin">
        <div v-if="isNotRole" class="w3-text-red w3-large w3-center">
            Nincs jogosultsága a funkció használatáshoz!
        </div>
        <div v-else>
            <div class="w3-bar w3-blue-grey ">
                <div class="w3-bar-item w3-padding uppercase">
                    <span v-if="hike.name!=''">{{hike.name}} szerkesztése</span>
                    <span v-else>Túra szerkesztése</span>
                </div> 
                <div v-if="hike.id" class="w3-dropdown-click w3-right ">
                <button v-on:click="toggleMenu" class="w3-button w3-hover-blue-grey w3-blue-grey w3-large">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<font-awesome-icon icon="ellipsis-v"></font-awesome-icon></button>
                <div id="dropdown-content" class="w3-dropdown-content w3-bar-block w3-border-left w3-border-right w3-border-bottom" style="right:0" v-on:click="closeMenu">
                    <a href="#" class="w3-bar-item w3-button" v-on:click.prevent="setPanel('alapadatok')"><font-awesome-icon icon="clipboard-list"></font-awesome-icon> Alapadatok</a>
                    <a href="#" class="w3-bar-item w3-button" v-on:click.prevent="setPanel('pontok')"><font-awesome-icon icon="map-marker-alt"></font-awesome-icon> Ellenőrzőpontok</a>
                    <a href="#" class="w3-bar-item w3-button" v-on:click.prevent="setPanel('dokumentumok')"><font-awesome-icon icon="file-alt"></font-awesome-icon> Dokumentumok</a>                
                </div>
                </div>
            </div> 
            <div v-if="panel=='alapadatok'" class="w3-row w3-margin-left" >
                <div class="w3-text-blue w3-large w3-margin-top">Alapadatok</div>
                <form @submit.prevent>
                    <div class="w3-row">
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Állapot</label>
                                <select class="w3-select w3-border w3-light-grey" v-model="hike.status">                                
                                    <option v-for="(item, index) in $appData.status" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                                </select>
                            </div>
                        </div>                     
                    </div>
                    <div class="w3-row">
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Azonosító</label>
                                <input v-model="hike.id" class="w3-input w3-border w3-grey" disabled>
                            </div>                
                        </div> 
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-top">
                                <label class="w3-text-blue">Pontszám</label>
                                <input disabled v-model="ggpoint" type="number" class="w3-input w3-border w3-grey" >                         
                            </div>
                        </div>  
                    </div>
                    <div class="w3-margin-right w3-margin-bottom w3-margin-top">
                        <label class="w3-text-blue">Túra neve</label>
                        <span v-if="isNewAndDelete">
                            <input v-model="hike.name" class="w3-input w3-border w3-light-grey">                         
                        </span>
                        <span v-else> <!-- A túra neve nem módosítható, ha már van teljesítő-->
                            <!--<input disabled v-model="hike.name" class="w3-input w3-border w3-grey">-->
                            <input v-model="hike.name" class="w3-input w3-border w3-grey">
                        </span>
                    </div>
                    <div class="w3-row">
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Teljesítés módja</label>
                                <select class="w3-select w3-border w3-light-grey" v-model="hike.mode">
                                    <option v-for="(item, index) in $appData.mode" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                                </select>
                            </div>
                        </div>  
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Díjazás</label>
                                <select class="w3-select w3-border w3-light-grey" v-model="hike.prise">
                                <option v-for="(item, index) in $appData.prise" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                                </select>
                            </div>
                        </div> 
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Ár</label>
                                <input v-model="hike.price" type="number" class="w3-input w3-border w3-light-grey" >                         
                            </div>
                        </div>                     
                    </div>
                    <div class="w3-row">
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Típus</label>
                                <select class="w3-select w3-border w3-light-grey" v-model="hike.type">
                                    <option v-for="(item, index) in $appData.type" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                                </select>                            
                            </div>
                        </div>  
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Táv (km)</label>
                                <input v-model="hike.distance" type="number" class="w3-input w3-border w3-light-grey">                         
                            </div>
                        </div>  
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Szint (m)</label>
                                <input v-model="hike.level" type="number" class="w3-input w3-border w3-light-grey" >                         
                            </div>                        
                        </div>                                                                                         
                    </div>                     
                    <div class="w3-row">
                        <div class="w3-quarter w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Szintidő-K (h)</label>
                                <input v-model="hike.timeTour" type="number" class="w3-input w3-border w3-light-grey" >                         
                            </div>
                        </div>  
                        <div class="w3-quarter w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Szintidő-T (h)</label>
                                <input v-model="hike.timeHike" type="number" class="w3-input w3-border w3-light-grey" >                         
                            </div>
                        </div>
                        <div class="w3-quarter w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Szintidő-F (h)</label>
                                <input v-model="hike.timeRun" type="number" class="w3-input w3-border w3-light-grey" >                         
                            </div>
                        </div>                                                                                                                                      
                        <div class="w3-quarter w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Szintidő-B (h)</label>
                                <input v-model="hike.timeBike" type="number" class="w3-input w3-border w3-light-grey" >                         
                            </div>
                        </div>                    
                    </div>
                    <div class="w3-row">
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Név</label>
                                <input v-model="hike.contactname" type="text" class="w3-input w3-border w3-light-grey">                         
                            </div>
                        </div> 
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">E-mail</label>
                                <input v-model="hike.contactemail" type="email" class="w3-input w3-border w3-grey">
                            </div>
                        </div> 
                    </div>
                    <div class="w3-row">
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Telefonszám</label>
                                <input v-model="hike.contactphone" type="tel" class="w3-input w3-border w3-light-grey">                         
                            </div>
                        </div> 
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Régió</label>
                                <select class="w3-select w3-border w3-light-grey" v-model="hike.landscape">
                                    <option v-for="(item, index) in $appData.landscape" :key="index" v-bind:value="item.id">{{item.name}}</option>
                                </select>                            
                            </div>
                        </div>
                        <div class="w3-third w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Járás</label>
                                <select class="w3-select w3-border w3-light-grey" v-model="hike.district">
                                    <option v-for="(item, index) in $appData.districts" :key="index" v-bind:value="item">{{item}}</option>
                                </select> 
                            </div>
                        </div>                      
                    </div>
                    <div class="w3-row">
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Web</label>
                                <input v-model="hike.web" type="url" class="w3-input w3-border w3-light-grey">                         
                            </div>
                        </div>
                        <div class="w3-half w3-mobile">
                            <div class="w3-margin-right w3-margin-bottom">
                                <label class="w3-text-blue">Facebook</label>
                                <input v-model="hike.facebook" type="url" class="w3-input w3-border w3-light-grey">                         
                            </div>
                        </div>
                    </div>

                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Leírás</label>
                        <textarea v-model="hike.description" rows=15 class="w3-input w3-border w3-light-grey"></textarea> 
                    </div>
                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Üzenet</label>
                        <textarea v-model="hike.message" class="w3-input w3-border w3-light-grey"></textarea>                 
                    </div>
                    <div v-if="hike.id" v-on:click="saveHike" class="w3-right w3-margin-bottom w3-margin-right w3-button w3-padding w3-blue w3-hover-blue">Módosítások mentése</div>                
                    <div v-if="!hike.id" v-on:click="saveHike" class="w3-right w3-margin-bottom w3-margin-right w3-button w3-padding w3-blue w3-hover-blue">Alapadatok mentése</div>
                </form>  
            </div>

            <div v-if="panel=='pontok'" class="w3-row w3-margin-left" >
                <div class="w3-text-blue w3-large w3-margin-top w3-margin-bottom">Ellenőrzőpontok</div>    
                <div v-if="isNewAndDelete" class="w3-row">
                    <div v-on:click="newPoint" class=" w3-margin-bottom w3-button w3-blue-grey w3-left w3-margin-right">Új pont</div>
                    <FileReader title="Pontok fájlból (json)" class=" w3-margin-bottom w3-left w3-margin-right" @load="loadPointsJson($event)"></FileReader>  
                    <div v-on:click="savePoints" class=" w3-margin-bottom w3-button w3-green w3-left w3-margin-right">Pontok mentése</div>
                </div>
                <hr>
                <div class="w3-large w3-text-blue w3-margin">Táv- és szintadatok szerkesztése</div>
                <div class="w3-margin-right w3-margin-bottom">
                    <table v-if="pointList.length>0" class="w3-table-all w3-small">
                        <tr class="w3-light-blue">
                            <td width="200px">Ellenőrzőpont</td>
                            <td>Sorrend</td>
                            <td>Résztáv (km)</td>
                            <td>Rész szint (m)</td>                        
                    </tr>
                        <tr v-for="(item, index) in orderedPointsList" :key="index">
                            <td>{{item.name}}</td>
                            <td><input class="w3-input w3-border" v-model="item.ordernum"></td>
                            <td><input class="w3-input w3-border" v-model="item.prevDist"></td>
                            <td><input class="w3-input w3-border" v-model="item.prevLevel"></td>                        
                        </tr>
                        <tr class="w3-blue-grey">
                            <td></td>
                            <td>Összesen</td>                        
                            <td>{{sumPointList.sumPrevDist | filterFloatRound}} km</td>
                            <td>{{sumPointList.sumPrevLevel}} m</td>                        
                        </tr>
                    </table>
                    <div class="w3-right">
                        <div v-on:click="levelUpdate()" class=" w3-margin-bottom w3-button w3-green">Szintadatok pontosítása</div>
                    </div>    
                </div>

                <hr>
                <div class="w3-large w3-text-blue w3-margin">Pont adatok szerkesztése</div>
                <div v-for="(item, index) in orderedPointsList" :key="index" class="w3-margin-bottom">
                    <div v-on:click="setPointShowIndex(index)" class="cursorpointer w3-light-blue w3-margin-right w3-padding">{{pointList[index].name}}</div>
                    <div v-if="pointShowIndex==index" class="w3-margin-top">
                        <div class="w3-row">
                            <div class=" w3-mobile">
                                <div class="w3-margin-right w3-margin-bottom">
                                    <label class="w3-text-blue">Pont neve</label>
                                    <input v-model="pointList[index].name" type="text" class="w3-input w3-border w3-light-grey">
                                </div>
                            </div>
                        </div>
                        <div class="w3-row">                    
                            <div class="w3-quarter w3-mobile">
                                <div class="w3-margin-right w3-margin-bottom">
                                    <label class="w3-text-blue">Lat</label>
                                    <input v-model="pointList[index].lat" type="number" class="w3-input w3-border w3-light-grey" >                         
                                </div>
                            </div> 
                            <div class="w3-quarter w3-mobile">
                                <div class="w3-margin-right w3-margin-bottom">
                                    <label class="w3-text-blue">Lon</label>
                                    <input v-model="pointList[index].lon" type="number" class="w3-input w3-border w3-light-grey" >                         
                                </div>
                            </div> 
                            <div class="w3-quarter w3-mobile">
                                <div class="w3-margin-right w3-margin-bottom">
                                    <label class="w3-text-blue">Sugár</label>
                                    <input v-model="pointList[index].radius" type="number" class="w3-input w3-border w3-light-grey" >                         
                                </div>
                            </div>
                            <div class="w3-quarter w3-mobile">
                                <div class="w3-margin-right w3-margin-bottom">
                                    <label class="w3-text-blue">Térképen</label>
                                    <router-link :to="{ name: 'mainmap', params: { source: 'create-point', point: pointList[index] } }" >
                                        <div class="w3-button w3-input w3-padding w3-blue w3-center"><font-awesome-icon icon="map-marked-alt"></font-awesome-icon></div>
                                    </router-link>
                                </div>
                            </div> 
                        </div>  
                        <div class="w3-margin-right w3-margin-bottom">
                            <label class="w3-text-blue">Üzenet</label>
                            <input v-model="pointList[index].message" type="text" class="w3-input w3-border w3-light-grey">
                        </div>                                        
                        <div class="w3-margin-right w3-margin-bottom">
                            <label class="w3-text-blue">Leírás</label>
                            <textarea v-model="pointList[index].description" rows=10 class="w3-input w3-border w3-light-grey"></textarea>                         
                        </div>                                        
                        <div class="w3-margin-right w3-margin-bottom">
                            <label class="w3-text-blue">Kép Url</label>
                            <input v-model="pointList[index].imgUrl" type="text" class="w3-input w3-border w3-light-grey">
                        </div>                                        

                        <div class="w3-center w3-margin-right">
                            <div v-if="!pointList[index].id" v-on:click="savePoints()" class=" w3-margin-bottom w3-button w3-padding w3-green">Pont mentése</div>
                            <div v-if="pointList[index].id" v-on:click="savePoints()" class=" w3-margin-bottom w3-button w3-padding w3-green">Pont módosítása</div>
                            <div v-if="pointList[index].id && isNewAndDelete" v-on:click="deletePointConfirm(pointList[index])" class=" w3-margin-bottom w3-margin-left w3-button w3-padding w3-red">Pont törlése</div>                    
                        </div> 
                    <hr class="w3-margin-right">
                    </div>
                    
                </div>
            </div>

            <div v-if="panel=='dokumentumok'" class="w3-row w3-margin" >
                <div class="w3-text-blue w3-large w3-margin-top w3-margin-bottom">Dokumentumok</div>
                <form @submit.prevent>
                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Track URL</label>
                        <input v-model="hike.trackUrl" type="url" class="w3-input w3-border w3-light-grey">                         
                    </div>
                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Kép URL</label>
                        <input v-model="hike.imgUrl" type="url" class="w3-input w3-border w3-light-grey">                         
                    </div>
                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Galéria URL</label>
                        <input v-model="hike.galleryUrl" type="url" class="w3-input w3-border w3-light-grey">                         
                    </div>
                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Video URL</label>
                        <input v-model="hike.videoUrl" type="url" class="w3-input w3-border w3-light-grey">                         
                    </div>
                    <div class="w3-margin-right w3-margin-bottom">
                        <label class="w3-text-blue">Oklevél URL</label>
                        <input v-model="hike.dipSablon" type="url" class="w3-input w3-border w3-light-grey">                         
                    </div>
                </form>

                <hr>

                <div class="w3-text-blue w3-large">Egyéb dokumentumok</div>

                <table class="w3-table-all w3-small ">
                    <tr class="w3-green">
                        <td>#</td>
                        <td>Megnevezés</td>
                        <td>Típus</td>
                        <td>Url</td>   
                        <td>
                            <span class="cursorpointer" v-on:click="addDoc()"><font-awesome-icon icon="plus-square"></font-awesome-icon></span>
                        </td>
                    </tr>                        
                    <tr v-for="(item, index) in documents" :key="index" >
                        <td>{{index}}</td>
                        <td><input v-model="item.name" class="w3-input w3-border"></td>
                        <td><input v-model="item.type" class="w3-input w3-border"></td>
                        <td><input v-model="item.url" type="url" class="w3-input w3-border"></td>
                        <td>
                            <span class="cursorpointer w3-text-red" v-on:click="deleteDoc(index)"><font-awesome-icon icon="trash-alt"></font-awesome-icon></span>
                        </td>
                    </tr>
                </table>
                <div v-if="hike.id" v-on:click="saveHike" class="w3-right w3-margin-top w3-margin-bottom w3-button w3-padding w3-blue w3-hover-blue">Módosítások mentése</div>                                
            </div>
        </div>
    </div>   
  
</template>

<script>
import {store} from "../store.js";
const fb = require('../firebase.js');
import FileReader from "../components/FileReader";
export default {
    name: 'CreateHike',
    data() {
        return {
            isNotRole:false,
            panel:'alapadatok',
            pointShowIndex:null,
            isNewAndDelete:false,
            documents:null,
            hike: {
                id: null,
                name: '',
                type: 1,
                mode: 1,
                distance: 0,
                level: 0,
                timeTour: 0,
                timeHike: 0,
                timeRun: 0,
                timeBike: 0,
                ggpoint: 0,
                contactname: '',
                contactemail: '',
                contactphone: '',
                web:'',
                facebook:'',
                description: '',
                message: '',
                creatdate: null,
                creatuser: null,
                lon: '',
                lat: '',
                imgUrl: '',
                dipSablon:'',
                status: 1,
                trackUrl: '',
                galleryUrl:'',
                prise:0,
                price:0,
                landscape:0, //üres
                district:''
            },            
            pointList: [],
        }
    },
    components: {
        FileReader
    },
    computed: {
        sumPointList: function(){
            var sumPL={
                "sumPrevDist":0,
                "sumPrevLevel":0
            }
            for (var p in this.pointList){
                sumPL.sumPrevDist+=parseFloat(this.pointList[p].prevDist);
                sumPL.sumPrevLevel+=parseInt(this.pointList[p].prevLevel);
            }
            return sumPL;
        },

        orderedPointsList: function () {
            //this.pointList.sort((a,b) => (a.ordernum > b.ordernum) ? 1 : ((b.ordernum > a.ordernum) ? -1 : 0)); 
            return this.pointList;
        },
        
        ggpoint: function(){
            if (this.hike.mode==2) return Math.round((parseFloat(this.hike.distance*1)+parseFloat(this.hike.level/100))*0.6);
            else return Math.round(parseFloat(this.hike.distance*1)+parseFloat(this.hike.level/100));
        },
    },    
    methods:{
        addDoc(){
            var newDoc={
                name:'',
                type:'pdf',
                url:''
            }
            if (!this.hike.documents) this.hike.documents=[newDoc];
            else this.hike.documents.push(newDoc);
            this.documents=this.hike.documents;
        },
        deleteDoc(index){
            console.log(index);
            this.hike.documents.splice(index,1);
        },
        updateDoc(){            
            try{
                this.$showSpinner();
                if (!this.hike.documents) this.hike.documents=[];
                if (this.aktDoc.index==-1) this.hike.documents.push(this.aktDoc);                
                fb.UpdateHike(this.hike).then(res=>{
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-green','Mentés',"Az adatok mentése megtörtént."));                
                }).catch(e=>{        
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt a művelet során"));                 
                })
            }catch(e){
                console.log(e);                
            }            
        },              

        levelUpdate(){
            var sumPrevLevel=0;
            for (var p in this.pointList){
                sumPrevLevel+=parseInt(this.pointList[p].prevLevel);
            }
            var eSzorzo=this.hike.level/sumPrevLevel;
            for (var i in this.pointList) {
                this.pointList[i].prevLevel=parseInt(eSzorzo*this.pointList[i].prevLevel);
            }
        },
        closeMenu(){
            document.getElementById("dropdown-content").style.display = 'none';
        },
        toggleMenu(){
            var m = document.getElementById("dropdown-content");
            if (m.style.display === 'block') {
                m.style.display = 'none';
            } else {
                m.style.display = 'block';
            }           
        },        
        setPointShowIndex(index){
            if (index==this.pointShowIndex) this.pointShowIndex=null;
            else this.pointShowIndex=index;
        },
        deletePointConfirm(p){
            let self = this;
            self.$dialog.confirm(this.$setDialogMsg("w3-yellow","Törlés","Biztosan törlöd ezt (" + p.name + ") a pontot?"))
            .then(function(dialog) {
                self.$showSpinner();
                fb.DeletePoint(p).then(res=>{
                    var dpId=p.id;
                    self.pointList = self.pointList.filter(function( obj ) {
                        return obj.id !== dpId;
                    });
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-green','Pont törlése',"A pont törlése megtörtént."));
                }).catch(e=>{   
                    console.log(e);                    
                    self.$hideSpinner();
                    self.$dialog.alert(self.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a pont törlése során.'));
                })  
            });  
        }, 
        setGeogo(){
            this.$storage.set('actualGeogo', this.hike);
        },
        savePoints(){            
            this.$showSpinner();
            var startPosition=this.$startPosition(this.pointList);
            this.hike.lat=startPosition.lat;
            this.hike.lon=startPosition.lon;
            for (var p in this.pointList) {
                this.pointList[p]=this.$parsePoint(this.pointList[p]);
            }
            fb.UpdatePoints(this.pointList,this.hike).then(res=>{
                this.pointList=res;
                this.pointList.sort((a,b) => (a.ordernum > b.ordernum) ? 1 : ((b.ordernum > a.ordernum) ? -1 : 0)); 
                this.pointShowIndex=null;
                this.$hideSpinner();
                this.$dialog.alert(this.$setDialogMsg('w3-green','Mentés',"Az adatok mentése megtörtént"));                
            }).catch(e=>{        
                console.log(e);                
                this.$hideSpinner();
                this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt az adatok mentése során"));                 
            })             
        },
        newPoint(){            
            var index=this.pointList.length;            
            if ((index>0) && (!this.pointList[index-1].id)) {
                this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés',"Újabb pont létrehozása előtt el kell menteni az előző pont adatait."));                 
            } else {
                var p = { 
                    "id": null,
                    "name": "Új pont",
                    "lon": "47", 
                    "lat": "19", 
                    "radius": 50,
                    "ordernum":index+1,
                    "message": "",
                    "hikeId": this.hike.id,
                    "type": 1,
                    "prevDist":0,
                    "prevLevel":0 
                };
                if (index>0) {                
                    p.lon=this.pointList[index-1].lon;
                    p.lat=this.pointList[index-1].lat;
                }
                this.pointList.push(p);
                this.setPointShowIndex(index);
            }
        },
        setPanel(value){
            this.panel=value;
        },              
        loadPointsJson(data){ 
            var index=this.pointList.length; 
            var json=JSON.parse(data);                     
            try{
                var wPoints=[];
                for (var i in json.features){
                    var f=json.features[i];  
                    if (f.geometry.type=="Point") {
                        var newWP={
                            "name":f.properties.name,
                            "cord":f.geometry.coordinates
                        }
                        wPoints.push(newWP);
                    }                              
                    if (f.geometry.type=="MultiLineString") {                  
                        var cords=f.geometry.coordinates[0]; 
                    }
                }     
                for (var j in wPoints) {
                    var d=0;
                    var mind=10;
                    var minCord=null;
                    for (var i in cords){
                        d=this.$distance(cords[i][1],cords[i][0],wPoints[j].cord[1],wPoints[j].cord[0]);                      
                        if (d<mind) {
                            mind=d;
                            minCord=cords[i];
                        }
                    }
                    wPoints[j].minCord=minCord;
                }
                var sumDist=0;
                var sumLev=0;
                var subDist=0;
                var subLev=0;
                var index=0;                                 
                for (var i=0; i<cords.length; i++) {                
                    if (wPoints[index] && (cords[i]==wPoints[index].minCord) || (index==0)) {
                        wPoints[index].subDist=Number((parseFloat(subDist)).toFixed(1));
                        wPoints[index].subLev=subLev;
                        sumDist+=wPoints[index].subDist;
                        sumLev+=wPoints[index].subLev
                        subDist=0;
                        subLev=0;
                        index++;   
                    } else {                
                        var next=parseInt(i)+parseInt(1);
                        if (cords[next]){
                            var up=cords[next][2]-cords[i][2];
                            if (up>1) subLev+=up;
                            var d=this.$distance(cords[i][1],cords[i][0],cords[next][1],cords[next][0]);
                            subDist+=parseFloat(this.$distance(cords[i][1],cords[i][0],cords[next][1],cords[next][0]));
                        }
                    }                
                }
                if (this.hike.type==1) {//Körtúra esetén a rajt pontot cél pontnak is betesszük
                    var targetWp = Object.assign({}, wPoints[0]);                
                    targetWp.subDist=Number((parseFloat(subDist)).toFixed(1));
                    targetWp.subLev=subLev;
                    sumDist+=targetWp.subDist;
                    sumLev+=targetWp.subLev;
                    wPoints.push(targetWp); 
                }

                for (var i = 0; i < wPoints.length; i++) { 
                    var p = { 
                        "id": null,
                        "name": wPoints[i].name,
                        "lon": wPoints[i].minCord[1], 
                        "lat": wPoints[i].minCord[0], 
                        "radius": 50,
                        "ordernum":i+1,
                        "message": "",
                        "hikeId": this.hike.id,
                        "type": 1,
                        "prevDist":wPoints[i].subDist,
                        "prevLevel":wPoints[i].subLev,
                    };
                    this.pointList.push(p);
                }                               
                
            } catch(e){
                console.log(e);                
                this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt a pontok betöltése során."));                 
            }
            
        },        
        saveHike(){
            if (this.hike.name=="") this.$dialog.alert(this.$setDialogMsg('w3-yellow','Mentés',"A túra nevének megadása kötelező!")); 
            else {
                if (this.hike.contactname=="") this.$dialog.alert(this.$setDialogMsg('w3-yellow','Mentés',"A név megadása kötelező!"));                 
                else {
                    this.$showSpinner();
                    this.hike.creatdate=new Date().getTime();
                    this.hike.ggpoint=this.ggpoint;
                    this.hike=this.$parseHike(this.hike); 
                    fb.UpdateHike(this.hike).then(res=>{
                        this.hike=res;
                        this.$storage.set('modHike', this.hike);
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-green','Mentés',"Az adatok mentése megtörtént")); 
                    }).catch(e=>{   
                        console.log(e);          
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok mentése során.'));
                    }) 
                }
            }
        }
    },
    created: function(){ 
        if (this.$store.getters.userProfile) {
            if (fb.IsRouteAdmin(this.$store.getters.userProfile.uid)) {
                try{
                    var mHike=this.$storage.get('modHike', null); 
                    if (mHike) {
                        this.hike=mHike;
                        this.$showSpinner();
                        fb.GetPoints(this.hike.id).then(res=>{
                            var points=[];
                            Object.keys(res.points).map(function(objectKey, index) {
                            points.push(res.points[objectKey]);
                            });  
                            this.pointList=points;
                            
                            this.pointList.sort((a,b) => (a.ordernum > b.ordernum) ? 1 : ((b.ordernum > a.ordernum) ? -1 : 0)); 

                            var createdPoint=this.$storage.get('actualCreatedPoint', null);//térkép nézetben beállított módosítások átvezetése
                            if (createdPoint) {
                                var isExist=false;
                                this.panel='pontok';
                                for (var i in this.pointList) {
                                    if (this.pointList[i].id==createdPoint.id) {
                                        this.pointList[i]=createdPoint;
                                        this.setPointShowIndex(createdPoint.ordernum-1);
                                        isExist=true;
                                        break;
                                    }     
                                }
                                if (!isExist) {
                                    this.pointList.push(createdPoint);
                                    this.setPointShowIndex(createdPoint.ordernum-1);
                                }
                                this.$storage.set('actualCreatedPoint', null);
                            }
                            fb.GetHikeCertifyesCount(mHike.id).then(count=>{
                                if (count==0) this.isNewAndDelete=true; //Ha még nincs teljesítő, akkor lehet új pontot létrehozni és pontot törölni és túra nevét módosítani
                                this.$hideSpinner();
                            }).catch(e=>{
                                this.isNewAndDelete=true;
                                this.$hideSpinner();
                                console.log(e);
                            }); 
                        }).catch(e=>{
                            console.log(e); 
                            this.$hideSpinner();
                            this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt a pontadatok letöltése során"));                 
                        });            
                    } else {
                        this.hike.creatuser = this.$store.getters.userProfile.uid;
                        this.hike.contactname = this.$store.getters.userProfile.name;
                        
                        this.hike.contactemail = this.$store.getters.userProfile.email;
                        this.isNewAndDelete=true;
                    }
                    this.documents=this.hike.documents;
                }catch(e){
                    console.log(e);
                }
            } else {
                this.isNotRole=true;
            }
        } else this.isNotRole=true;
    }
}
</script>

